import { useTranslation } from 'react-i18next'
import { ConfirmDeleteDialog } from './ConfirmDeleteDialog'
import type { Documentable } from '@/types'

interface Props {
  document: Documentable | null
  onClose: () => void
  onConfirm: () => void | Promise<void>
  isPending?: boolean
}

// Delete document confirmation — Figma 1336:31123.
export function DeleteDocumentDialog({
  document,
  onClose,
  onConfirm,
  isPending = false,
}: Props) {
  const { t } = useTranslation('clients')

  return (
    <ConfirmDeleteDialog
      open={!!document}
      onOpenChange={o => !o && onClose()}
      title={t('documents.deleteDialog.title')}
      description={t('documents.deleteDialog.confirm')}
      confirmLabel={t('documents.deleteDialog.confirmButton')}
      onConfirm={onConfirm}
      busy={isPending}
    />
  )
}
